import { useState } from "react";
import { Typography, Box, dialogClasses } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import { MzRadioGroup, MzRadio } from "@markaaz/ui/MzRadioControls";
import { MzDialog, MzDialogContent, MzDialogActions } from "@markaaz/ui/MzDialogControls";

const sx = {
  root: {
    [`.${dialogClasses.paper}`]: {
      width: "516px"
    }
  },
  content: {
    display: "flex",
    alignItems: "revert"
  },
  checkbox: {
    display: "flex",
    flexWrap: "wrap",
    mt: 12,
    color: "common.black",
    label: {
      width: "200px"
    }
  }
};

export default function UserForm({ open, inProgress, onClose, onDownload }) {
  const [selected, setSelected] = useState("pdf");

  function onChange(e, value) {
    setSelected(value);
  }

  function handleSubmit() {
    onDownload(selected);
  }

  return (
    <MzDialog sx={sx.root} open={open}>
      <MzDialogContent sx={sx.content}>
        <Typography variant="h5">Download Your Report </Typography>
        <Typography mt={7}>Please select which report format(s) you would like to download. </Typography>
        <Box sx={sx.checkbox}>
          <MzRadioGroup row value={selected} onChange={onChange}>
            <MzRadio value="pdf" label="PDF File" />
            <MzRadio value="excel" label="Excel File" />
            <MzRadio value="json" label="JSON File" />
            <MzRadio value="csv" label="CSV File" />
          </MzRadioGroup>
        </Box>
      </MzDialogContent>
      <MzDialogActions
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <MzButton variant="outlined" color="secondary" size="large" onClick={onClose}>
          Close
        </MzButton>
        <MzButton variant="contained" size="large" disabled={inProgress} loading={inProgress} onClick={handleSubmit}>
          Download
        </MzButton>
      </MzDialogActions>
    </MzDialog>
  );
}
